import React, { useState, useEffect, useCallback } from 'react'
import { Table, toaster, Checkbox } from 'evergreen-ui'
import BtnDefault from '../../Components/BtnDefault';
import axios from '../../Utils/axios';

const ResourceForm = ({
  save, employeeResource
}) => {
  const [resources, setResources] = useState([])

  const getResources = useCallback(async () => {
    try {
      const { data } = await axios.get(`/company/resources/employees/${employeeResource.employeeId}`)
      setResources(data.resources)

    } catch (error) {
      toaster.danger('Falha ao Buscar dados')
    }
  }, [employeeResource])
  

  useEffect(() => {
    if (employeeResource && employeeResource.employeeId ) {
      getResources()
    }
  }, [getResources, employeeResource])

  const findAndCheck = (id, checked) => {
    return resources.map((resource, i) => {
      return id === resource.__id__ ? { ...resource, active: checked } : resource;
    })
  }

  const findAllChecked = () => {
    return resources.filter(resource => resource.active).map(resource => ({ __id__: resource.__id__ }));
  }

  return (
    <React.Fragment>
      <Table style={{ marginRight: 10, marginLeft: 10, marginTop: 0 }}>
        <Table.VirtualBody allowAutoHeight={true} height={360}>
          {resources.map(resource => (
            <Table.Row key={resource.__id__}>
              <Table.TextCell flexBasis={60} flexShrink={0} flexGrow={0}>
                <Checkbox
                  checked={!!resource.active}
                  onChange={e => setResources(findAndCheck(resource.__id__, e.target.checked))}
                />
              </Table.TextCell>
              <Table.TextCell >{resource.name}</Table.TextCell>
            </Table.Row>
          ))}
        </Table.VirtualBody>

        <BtnDefault
          onClick={() => save({ resources: findAllChecked() })}
          iconBefore='tick'
          height={40} appearance="primary">
          Confirmar
            </BtnDefault>
      </Table >
    </React.Fragment>
  )
}

export default ResourceForm